import { trace } from '@opentelemetry/api';

export default class HoneycombTracer {
  constructor() {
    this.tracer = trace.getTracer('honeycomb-web-instrumentation');
    this.allowedDomainsList = [
      'siscostaging-test.myshopify.com',
      'joao-theme-extension-test.myshopify.com',
      'bta-theme-extension-test.myshopify.com',
      'vladislav-volkov-bta-dev.myshopify.com',
      'dangelo-staging.myshopify.com',
      'legros-parker-and-harris6290.myshopify.com',
      'lisastars.com',
      'ascentoutdoors.com',
      'shop.millermulligans.com',
      'dresshireaustralia.com.au',
    ];
  }

  startActiveSpan(...args) {
    if (!this.allowedDomainsList.includes(window.location.hostname)) return;

    this.tracer.startActiveSpan(...args);
  }
}
